import { render, staticRenderFns } from "./thanks.vue?vue&type=template&id=7db5a907&lang=html"
import script from "./thanks.vue?vue&type=script&lang=js"
export * from "./thanks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports